import { Component, OnInit } from '@angular/core';
import { ITableColumnHeader } from '../../models/table-column-header';
import { Subscription } from 'rxjs';
import { SharedService } from '../../providers/shared.service';
import { ApiService } from '../../providers/api.service';
import { MatDialog } from '@angular/material/dialog';
import { NavigationService } from '../../providers/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SM_CONSTANTS } from '../../shared/constants/sm-constants';
import { DeactivateBusinessComponent } from '../businesses/deactivate-business/deactivate-business.component';
import { ViewDetailsComponent } from './view-details/view-details.component';

@Component({
  selector: 'sm-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.scss']
})
export class ReferralComponent implements OnInit {
  messageList: any[] = [];
  public loader: boolean = false;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "referral code",
      columnProperty: "referral_code"
    },
    {
      columnName: "referrer name",
      columnProperty: "referee_name"
    },
    {
      columnName: "referrer account id",
      columnProperty: "reffery_account_id"
    },
    {
      columnName: "account id",
      columnProperty: "account_id"
    },
 
    {
      columnName: "use date",
      columnProperty: "use_date"
    },
    {
      columnName: "status",
      columnProperty: "status"
    },
  ];
  private _apiSubscription: Subscription;
  clickEventSubscription: Subscription;
  constructor(private sharedService: SharedService, private _apiService: ApiService,private dialog: MatDialog, private _navService: NavigationService, private router: Router, private route: ActivatedRoute) { 
    this._navService.hideSidebarAndNav = false;
    this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
      this.ngOnInit();
    })
    
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_REFERRAL_ACTIVITY_RESULT){
        console.log(resData);
        this.messageList = resData.result ? resData.result : [];
        this.messageList =     this.messageList.sort((dataA:any, dataB:any) =>
        ((+new Date(dataB['use_date'])) - (+new 
        Date(dataA['use_date'])))
 
     )
        this.messageList.forEach((item )=> {

          // item.referral_code = item.referral_code.slice(0,30) + '...'
         
          if(item.status == '0'){
            item.status = 'Unused'
          }
          if(item.status == '1'){
            item.status = 'Used'
          }
     
         
        })
            console.log( this.messageList);
        
      }
      this.loader = false;
    });
    // this.loader = false;
  }

  ngOnInit(): void {
    this.loader =true
    this._apiService.getReferral();
  }

  activateDeactivateReferralCode(hashId:any, status:any){

    const bodyData = {
      
        hashId: hashId,
        status: status
      
    }
    this._apiService.updateReferralActivityStatus(bodyData)
    setTimeout(() => {
      this.ngOnInit()
    }, 1500);
  }

  viewDetails(rowvalue:any){
    console.log(rowvalue);
    this.dialog.open(ViewDetailsComponent, {
      data: rowvalue,
      width: '500px',
      panelClass: 'user-profile-dialog'
    });
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    this.clickEventSubscription.unsubscribe()
  }

}
